import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { variables } from '../variables';

@customElement('apt-detail-box')
export class AptDetailBox extends LitElement {
  @property({ type: String })
  boxtitle = '';

  @property({ type: String })
  testselector = '';

  @property({ type: String })
  textorientation = 'right';

  @property({ type: String })
  textdescription = '';

  @property({ type: String })
  numbercolor = '';

  static override styles = [
    variables,
    css`
      :host {
        font-size: 14px;
      }
      small {
        font-size: 65%;
      }
      .card {
        margin-bottom: 10px;
        border: 1px solid #e2e2e2;
        padding: 10px;
      }
      .card-title {
        border-bottom: 2px solid #8dc63f;
        padding-bottom: 10px;
        font-size: 16px;
        margin-top: 10px;
        margin-bottom: 10px;
      }
      .number {
        font-size: 20px;
      }

      .align-right {
        text-align: right;
      }
      .align-left {
        text-align: left;
      }
      .orange {
        color: var(--orange);
      }
      .green {
        color: var(--green);
      }
    `,
  ];

  override render() {
    return html`<div class="card">
      <h4 class="card-title" data-test-selector="${this.testselector}">
        ${this.boxtitle}
      </h4>
      <div class="card-body align-${this.textorientation}">
        <span class="number ${this.numbercolor}">${this.textdescription}</span>
        <div>
          <slot name="body"></slot>
        </div>
      </div>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'apt-detail-box': AptDetailBox;
  }
}
